export enum PageType {
  AaaApplication = "AaaApplication",
  Landing = "Landing",
  IdXboxApplication = "IdXboxApplication",
  PitchApplication = "PitchApplication",
  Error = "Error",
}
